"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * REST API Detection Catalog
 * This schema defines the REST API endpoints for the detection catalog
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DetectionSortByColumnToJSON = exports.DetectionSortByColumnFromJSONTyped = exports.DetectionSortByColumnFromJSON = exports.DetectionSortByColumn = void 0;
/**
 *
 * @export
 */
exports.DetectionSortByColumn = {
    Name: 'name',
    Description: 'description',
    FirstAddedTime: 'first_added_time',
    LastUpdateTime: 'last_update_time',
    Status: 'status',
    Source: 'source',
    Scope: 'scope',
    Content: 'content',
    Filename: 'filename',
    AllDetectionsExtracted: 'all_detections_extracted',
    ExternalId: 'external_id',
    DetectionType: 'detection_type'
};
function DetectionSortByColumnFromJSON(json) {
    return DetectionSortByColumnFromJSONTyped(json, false);
}
exports.DetectionSortByColumnFromJSON = DetectionSortByColumnFromJSON;
function DetectionSortByColumnFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.DetectionSortByColumnFromJSONTyped = DetectionSortByColumnFromJSONTyped;
function DetectionSortByColumnToJSON(value) {
    return value;
}
exports.DetectionSortByColumnToJSON = DetectionSortByColumnToJSON;
